import LeftLogo from 'Assets/Images/left-logo-bg.svg?raw';
import RightLogo from 'Assets/Images/right-logo-bg.svg?raw';
import WelcomeImage from 'Assets/Images/splash-welcome-bg.webp';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

function Splash() {
  const splashScreenImage: {
    left?: string;
    right?: string;
  } | null = JSON.parse(localStorage.getItem('splashScreenImage') || 'null') as {
    left?: string;
    right?: string;
  } | null;

  const getRawUrl = useCallback((url: string) => {
    const encodedSVG = encodeURIComponent(url);
    return `data:image/svg+xml,${encodedSVG}`;
  }, []);

  const leftImage: string | undefined = splashScreenImage?.left;
  const rightImage: string | undefined = splashScreenImage?.right;
  const { t } = useTranslation('task');
  return (
    <div className="absolute inset-0 animate-welcome-slide">
      <div
        className="relative flex h-full w-full items-center justify-center bg-cover bg-center"
        style={{ backgroundImage: `url(${WelcomeImage})` }}
      >
        <p className="absolute bottom-[18%] text-[12.5em] font-bold tracking-[0.02em] text-neutral-white">
          {t('hello')}
        </p>
        <div
          style={{ backgroundImage: `url(${getRawUrl(LeftLogo)})` }}
          className="absolute bottom-0 left-0 flex items-center justify-start bg-cover bg-center px-8 sm:h-[96px] sm:w-[300px] sm:px-4 md:h-[128px] md:w-[400px] md:px-6 lg:h-[191px] lg:w-[600px]"
        >
          {leftImage && (
            <img src={leftImage} alt="Left Logo" className="h-full object-contain object-center" />
          )}
        </div>
        <div
          style={{ backgroundImage: `url(${getRawUrl(RightLogo)})` }}
          className="absolute bottom-0 right-0 flex items-center justify-end bg-cover bg-center px-8 sm:h-[96px] sm:w-[192px] sm:px-4 md:h-[128px] md:w-[256px] md:px-6 lg:h-[191px] lg:w-[382px]"
        >
          {rightImage && (
            <img
              src={rightImage}
              alt="Right Logo"
              className="h-full object-contain object-center"
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default Splash;
